let config;

const hostname = window?.location?.hostname;
const localBaseAPIURI = "http://localhost:8080";
// const localBaseAPIURI = "https://achieve2-api.tal.deere.com";
const devlBaseAPIURI = "https://achieve2-api.tal.deere.com";
const prodBaseAPIARI = "https://achieve2-api.deere.com";

if (hostname === "localhost") {
  config = {
    issuer: "https://sso-dev.johndeere.com/oauth2/ausi7ypmsbq8PsmS50h7",
    redirectUri: `${window.location.origin}/login`,
    clientId: "0oatbic0cu4KnL8Z20h7",
    pkce: true,
    apiBaseURI: localBaseAPIURI,
  };
} else if (hostname === "achieve2.tal.deere.com") {
  config = {
    issuer: "https://sso-dev.johndeere.com/oauth2/ausi7ypmsbq8PsmS50h7",
    redirectUri: `${window.location.origin}/login`,
    clientId: "0oatbjfthktlbXrd30h7",
    pkce: true,
    apiBaseURI: devlBaseAPIURI,
  };
} else if (hostname === "achieve2.deere.com") {
  config = {
    issuer: "https://sso.johndeere.com/oauth2/aus9ifp2ecCEYpGNT1t7",
    redirectUri: "https://achieve2.deere.com/login",
    clientId: "0oaf6fujjrm3PBLlc1t7",
    pkce: true,
    scopes: ["openid", "profile"],
    apiBaseURI: prodBaseAPIARI,
  };
}

export default config;
